import React from 'react';
import * as MaterialIcons from '@material-ui/icons';
import * as WhizzIcons from '../components/icon/whizzIcons';
import * as CustomIcons from '../components/icon/customIcons';
import type { AllColorType, AllIconType, CustomIconType, GenderType, MaterialIconType, SizeType, WhizzIconType } from './types';
import StudentIcon from '../components/icon/Icon.student';
import StudentChartIcon from '../components/icon/Icon.studentChart';
import Student3dIcon from '../components/charts/student-scatter/components/StudentIcon';
import WhizzIcon from '../components/icon/Icon.whizz';
import MaterialIcon from '../components/icon/Icon.material';
import { GLOBAL_ICONS } from './vars';
import CustomIcon from '../components/icon/Icon.customIcon';

/**
 * Returns icon component based on icon value.
 * @param icon
 * @param size
 * @param color
 * @param persistColor
 */
export const getIconComponent = (icon: AllIconType, size: SizeType | number = 'md', color: AllColorType = 'primary', persistColor = false): JSX.Element => {
  if (Object.keys(WhizzIcons).find((key) => key === icon)) {
    return <WhizzIcon icon={icon as WhizzIconType} size={size} />;
  }
  if (Object.keys(MaterialIcons).find((key) => key === icon)) {
    return (
      <MaterialIcon
        icon={icon as MaterialIconType}
        size={size}
        color={color}
        isCustomFilterIcon={icon === GLOBAL_ICONS.filter}
        persistColor={persistColor}
      />
    );
  }
  if (Object.keys(CustomIcons).find((key) => key === icon)) {
    return <CustomIcon icon={icon as CustomIconType} size={size} color={color} persistColor={persistColor} />;
  }
  if (icon === 'StudentChart') {
    return <StudentChartIcon size={size} color={color} noBorder />;
  }
  if (icon === 'Student3d') {
    // Todo: enable color to be set. Currently the color type isn't compatiable with the Student3dIcon color type
    const allowedColors = [ 'male', 'female', 'other', 'black', 'primary' ];
    let color3d: GenderType | 'black' | 'primary';
    if (!allowedColors.includes(color)) {
      color3d = 'black';
    } else {
      color3d = color as GenderType | 'black' | 'primary';
    }
    return <Student3dIcon size={size} color={color3d} />;
  }

  return <StudentIcon size={size} borderColor={color} background={color} />;
};

export const saveAsCsv = (csvFile: string, fileName: string): void => {
  const blob = new Blob([ `\uFEFF${csvFile}` ], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute('download', fileName);
    link.click();
  }
};
